<script setup lang="ts">
const items = [
  {
    title: 'Smart Data Mapping',
    description: 'Sistem membaca kolom otomatis (nama, alamat, ekspedisi).',
    icon: 'material-symbols:cast-for-education-outline'
  },
  {
    title: 'Preview & Edit Sebelum Kirim',
    description: 'Pastikan semua data benar sebelum "go-live"',
    icon: 'material-symbols:inventory-rounded'
  },
  {
    title: 'Autio Label Printing',
    description: 'Cetak label pengiriman masal otomatis',
    icon: 'material-symbols:adf-scanner-outline'
  },
  {
    title: 'Real-Time Tracking Terpusat',
    description: 'Pantau status semua paket dari satu dashboard',
    icon: 'material-symbols:update'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Fitur Canggih untuk Pengiriman Massal Tanpa Error"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
